"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.DoorOpenOutlineSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var innerSvg = '<path d="M13,28H6a2,2,0,0,1-2-2V6A2,2,0,0,1,6,4h7V6H6V26h7Z"/><path d="M17,3.514l9,2.077V26.409l-9,2.077V3.514M15.762,1.2A.753.753,0,0,0,15,2V30a.753.753,0,0,0,.762.8.935.935,0,0,0,.212-.025l11.052-2.55A1.321,1.321,0,0,0,28,27V5a1.321,1.321,0,0,0-.974-1.225L15.974,1.225a.935.935,0,0,0-.212-.025Z"/><circle cx="20" cy="16" r="1"/>';
var DoorOpenOutlineSVG = function DoorOpenOutlineSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
exports.DoorOpenOutlineSVG = DoorOpenOutlineSVG;
DoorOpenOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(DoorOpenOutlineSVG);
exports.default = _default;